export default __webpack_public_path__ + "static/media/913.51d3e716.png";